import TransferList from '../../TransferList';

interface LabourItemDefinition {
  id: string;
  name: string;
}

interface LabourItemsAssignmentCardProps {
  availableItems: LabourItemDefinition[];
  assignedItems: LabourItemDefinition[];
  searchText: string;
  onSearchChange: (text: string) => void;
  onMoveToAssigned: (itemId: string) => void;
  onMoveToAvailable: (itemId: string) => void;
  loading?: boolean;
  optional?: boolean;
}

export function LabourItemsAssignmentCard({
  availableItems,
  assignedItems,
  searchText,
  onSearchChange,
  onMoveToAssigned,
  onMoveToAvailable,
  loading = false,
  optional = false,
}: LabourItemsAssignmentCardProps) {
  return (
    <section
      className="flex flex-col gap-3 border-t border-border-default pt-5"
      data-testid="labour-items-assignment-card"
    >
      <p className="type-body-md text-content-secondary">
        Select the labour items workers in this group can see when booking.
        {optional ? ' You can change these later.' : ''}
      </p>
      <TransferList
        availableItems={availableItems}
        assignedItems={assignedItems}
        searchText={searchText}
        onSearchChange={onSearchChange}
        onMoveToAssigned={onMoveToAssigned}
        onMoveToAvailable={onMoveToAvailable}
        loading={loading}
      />
    </section>
  );
}
